<div
  class="image-view"
  [class.image-view--auto-fit]="fit === 'auto'"
  #imageView>

  <!-- image -->
  <img
    class="image-view__image"
    [src]="src"
    [alt]="alt"
    [style.max-width]="fit === 'auto' && fitSize ? (fitSize + 'px') : '100%'"
    [style.max-height]="fit === 'auto' && fitSize ? (fitSize + 'px') : '100%'">

  <div class="image-view__overlay" (click)="handleFullscreen($event)" role="button" matTooltip="Expand">
    <app-icon icon="expand-alt" class="image-view__icon"></app-icon>
  </div>
</div>